import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useBoolean, useInterval } from 'react-use';
import styles from './timestamp.module.scss';

const Timestamp = (props) => {
  const { totalTime, onTimeout, heartbeat, loudness } = props;
  const [currentTime, setCurrentTime] = useState(0);
  const [isTimeout, toggleIsTimeout] = useBoolean(!totalTime);

  useInterval(() => {
    const newTime = currentTime + 1;
    setCurrentTime(newTime);
    if (newTime >= totalTime) {
      toggleIsTimeout(true);
      onTimeout && onTimeout();
    }
  }, isTimeout || !heartbeat ? null : 1000, [props]);

  const remainingTime = totalTime - currentTime;
  return (
    <>
      <div className={styles.container}>
        <div className={styles.microphoneStatus}>
          {new Array(5).fill(null).map((_, i) => (
            <i key={i} className={loudness > (i + 1) * 20 ? styles.mark : ''} />
          ))}
        </div>
      </div>
      <div className={styles.container}>
        <span>{`- 00:${remainingTime < 10 ? '0' : ''}${remainingTime}`}</span>
      </div>
    </>
  );
};

Timestamp.propTypes = {
  totalTime: PropTypes.number.isRequired,
  onTimeout: PropTypes.func,
  heartbeat: PropTypes.bool,
  loudness: PropTypes.number,
};

export default Timestamp;
